import { Input, StatusIcon, Tooltip } from 'alurkerja-ui'
import { useUiFromSpecContext } from '../../../EditorContextProvider'
import { stringToTitleCase } from '@/utils/functions/stringToTitleCase'
import React from 'react'
import { getElementDisplayName } from '../../utils/getElementDisplayName'

type EditLabelProps = {
  index: number
  element: string
  currentElementState: any
  setCurrentElementState: React.Dispatch<any>
}

export default function EditLabel(props: EditLabelProps) {
  const { index, element, currentElementState, setCurrentElementState } = props
  const { language } = useUiFromSpecContext()
  const tooltipContent = {
    en: 'This field supports multiple languages. When the language is switched from Indonesian to English',
    id: 'Field ini mendukung multibahasa. Saat bahasa diubah dari Inggris ke Indonesia',
  }

  return (
    <>
      <div key={index} className="p-3 py-2 space-y-1 rounded-sm ">
        <div className="flex items-center space-x-1">
          <span className="font-semibold">{stringToTitleCase(getElementDisplayName(element))}</span>
          <Tooltip content={tooltipContent[language || 'en']} trigger="click" zIndex={'50'}>
            <StatusIcon type="info" className="text-base" />
          </Tooltip>
        </div>
        <Input
          className="w-full"
          type="text"
          size="sm"
          rounded="lg"
          value={currentElementState[element]?.en || ''}
          onChange={(e) => {
            setCurrentElementState((prevState: any) => {
              return {
                ...prevState,
                [element]: {
                  ...prevState[element],
                  en: e.target.value,
                },
              }
            })
          }}
          suffix={<span className="text-xs text-gray-500">EN</span>}
        />
        <Input
          className="w-full"
          type="text"
          size="sm"
          rounded="lg"
          value={currentElementState[element]?.id || ''}
          onChange={(e) => {
            setCurrentElementState((prevState: any) => {
              return {
                ...prevState,
                [element]: {
                  ...prevState[element],
                  id: e.target.value,
                },
              }
            })
          }}
          suffix={<span className="text-xs text-gray-500">ID</span>}
        />
      </div>
    </>
  )
}
